import React, { useState } from 'react';
import { CreateCSSProperties, styled } from '@mui/styles';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';

import "./StyledTabs.scss"

export interface StyledTabsProps {
    children?: React.ReactNode;
    value: number;
    onChange: (event: React.SyntheticEvent, newValue: number) => void;
}

const styledTabsCssProperties = {
    backgroundColor: 'transparent',
    borderBottom: '1px solid #cbd2da',
    marginTop: '-8px',
    '& .MuiTabs-indicator': {
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: 'transparent',
    },
    '& .MuiTabs-indicatorSpan': {
        width: '105%',
        backgroundImage: 'linear-gradient(91deg, #49b6db, #d045fb)',
    }
};

const styledTabCssProperties: CreateCSSProperties<StyledTabProps> = {
    textTransform: 'none',
    fontFamily: 'Proxima Nova Bold',
    fontWeight: 'normal',
    fontSize: '15px',
    color: '#4a4a4a',
    background: 'transparent',
    flexDirection: 'row',
    flexGrow: 1,
    gap: '5px',
    opacity: '0.6',
    transition: 'opacity 200ms',
    marginRight: '7px',
    '&:hover': {
        cursor: 'pointer',
        opacity: '0.95',
    },

    '&.Mui-selected': {
        color: '#4a4a4a',
        opacity: '1',
        fontWeight: 'bold',
    },
    '&.Mui-focusVisible': {
        backgroundColor: '#fff',
    },
    '.MuiTab-iconWrapper': {
        marginBottom: '0px',
    },
    '&.settings': {
        fontSize: '12px',
    },

};

export const StyledTabs = styled((props: StyledTabsProps) => (
    <Tabs
        {...props}
        TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
    />
))({ ...styledTabsCssProperties, height: '62px' });

export const AutoHeightStyledTabs = styled((props: StyledTabsProps) => (
    <Tabs
        {...props}
        TabIndicatorProps={{ children: <span className="MuiTabs-indicatorSpan" /> }}
    />
))({ ...styledTabsCssProperties, height: 'auto' });

interface StyledTabProps {
    icon?: any,
    label: any;
}

export const StyledTab = styled((props: StyledTabProps) => (
    <Tab disableRipple {...props} />
))(({ theme }) => ({ ...styledTabCssProperties }));

export const StackedStyledTab = styled((props: StyledTabProps & { value: any }) => (
    <Tab disableRipple {...props} />
))(({ theme }) => ({ ...styledTabCssProperties, padding: "12px 8px" }));

interface TabPanelProps {
    children?: React.ReactNode;
    index: number;
    value: number;
    className?: string;
}

export const TabPanel = (props: TabPanelProps) => {
    const { children, value, index, ...other } = props;

    return (
        <div
            className="tabpanel"
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <>{children}</>
            )}
        </div>
    );
}